import check_checkbox from './contact-form-gdpr.js';
import wp_sliders from './wp_sliders.js';
import {
  max_height_double_image_block,
  image_text_fill_height,
  animate_achievement,
  animate_number_when_scrolling,
  imagebank_block_functionality,
  embed_video,
  block_column_images,
  block_column_fullwidth,
  parallax_widgets
 } from './wp_block_scripts.js';

import mobile_menu from './mobile-menu.js';
import header from './header.js';
import { sticky_header } from './header.js';
import { wrap_multiple_widget_areas, wrap_woocommerce_shop_elements } from './nsgk_old_adaptions';
import sortFunctions from './wc-sort.js';

export default function nsgk_wp() {
  scale_hero_text();
  init();
  check_checkbox();
  max_height_double_image_block();
  image_text_fill_height();
  imagebank_block_functionality();
  embed_video();
  // block_column_fullwidth();
  // block_column_images();
  wp_sliders();
  header();
  sortFunctions();

  //Anpassningar för gamla temat
  wrap_multiple_widget_areas();
  wrap_woocommerce_shop_elements();

  let interval = setInterval(()=> {
    parallax_widgets();
}, 500);


  $(window).load(()=> {
    block_column_images();
    block_column_fullwidth();
  });

  function init() {
    sticky_header($(window).scrollTop());

    $(window).scroll(function (event) {
      sticky_header();
    });

    // $(window).scroll(animate_number_when_scrolling);

    $(window).on('resize', function() {
      max_height_double_image_block();
      if (window.innerWidth > 960) {
        $('.navigation').removeClass('open');
      }
    });

    // function for mobile hide header when scroll down / show when scroll up
    (function(){
      let doc = document.documentElement;
      let w = window;
      let prevScroll = w.scrollY || doc.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;
      let header = document.getElementById('site-header');
      let checkScroll = function() {
        if (window.outerWidth < 1024) {
          curScroll = w.scrollY || doc.scrollTop;
          if (curScroll > prevScroll) {
            direction = 2;
          }
          else if (curScroll < prevScroll) {
            direction = 1;
          }
          if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
          }
          prevScroll = curScroll;
        }
      };
      let toggleHeader = function(direction, curScroll) {
        if (direction === 2 && curScroll > 90) {
          header.classList.add('hide');
          prevDirection = direction;
        }
        else if (direction === 1) {
          header.classList.remove('hide');
          prevDirection = direction;
        }
      };
      window.addEventListener('scroll', checkScroll);
    })();
  }

  (function() {
    $("#burger-menu-open").parent().click(function() {
      $('.burger-menu', this).toggleClass('open');
      $(this).toggleClass('open');
      $('.mobile-menu').toggleClass('show');
      $('.open-btn').toggleClass('open');

      if (!$('.mega-menu-desktop').hasClass('active')) {
        $('.mega-menu-desktop').addClass('active');
        $('.mega-menu-desktop').slideDown(250);
        $('body').addClass('mega-menu-open');
      } else {
        $('.mega-menu-desktop').removeClass('active');
        $('.mega-menu-desktop').slideUp(250);
        $('body').removeClass('mega-menu-open');
      }
    });
  })();

  //Anpassa textstorlek i heroblocket för att inte bryta ord
  function scale_hero_text() {
    if ((window.outerWidth) < 768 && $('.hero-text').length > 0 && $('.hero-text').width() < $('.hero-text > span').width()) {
      while ($('.hero-text').width() < $('.hero-text > span').width()) {
        var fontsize = parseFloat($('.hero-text > span').css('font-size'));
        fontsize = --fontsize;
        $('.hero-text > span').css('font-size', fontsize + 'px');
      }
    }
  }
}
